'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UIModal from 'UIComponents/dialog/UIModal';
import AdwordsAdAccountCreation from 'ads-account-connection/components/ad-accounts/AdwordsAdAccountCreation';
import AdwordsAdAccountBillingSetup from 'ads-account-connection/components/ad-accounts/AdwordsAdAccountBillingSetup';
import AdwordsAdAccountSetupComplete from 'ads-account-connection/components/ad-accounts/AdwordsAdAccountSetupComplete';
import { ACCOUNT_SETUP_STEPS } from 'ads-account-connection/lib/AdwordsSetupStatus';
const ACCOUNT_SETUP_BY_STEPS = {
  [ACCOUNT_SETUP_STEPS.CREATE_ACCOUNT]: AdwordsAdAccountCreation,
  [ACCOUNT_SETUP_STEPS.SETUP_BILLING]: AdwordsAdAccountBillingSetup,
  [ACCOUNT_SETUP_STEPS.SETUP_COMPLETE]: AdwordsAdAccountSetupComplete
};

const AdwordsAdAccountSetupModal = ({
  onCancel,
  currentStep,
  onStepChange,
  inviteLink,
  setInviteLink,
  networkUserId,
  adAccountId,
  setAdAccountId,
  onSelect,
  refetchAccounts,
  trackEvent,
  isDeveloperPortal
}) => {
  const AdwordsSetupComponent = ACCOUNT_SETUP_BY_STEPS[currentStep];
  return /*#__PURE__*/_jsx(UIModal, {
    width: 500,
    children: /*#__PURE__*/_jsx(AdwordsSetupComponent, {
      onCancel: onCancel,
      currentStep: currentStep,
      onStepChange: onStepChange,
      inviteLink: inviteLink,
      setInviteLink: setInviteLink,
      networkUserId: networkUserId,
      adAccountId: adAccountId,
      setAdAccountId: setAdAccountId,
      onSelect: onSelect,
      refetchAccounts: refetchAccounts,
      trackEvent: trackEvent,
      isDeveloperPortal: isDeveloperPortal
    })
  });
};

export default AdwordsAdAccountSetupModal;